import React from 'react'
import './DisclaimerText.css'

function DisclaimerText() {
  return (
    <div className='text-muted small disclaimer-text-mobile'>
        <p>Disclaimer: The KingSale platform is used entirely at your own discretion and at your own risk. 
        We accept no liability for any loss occasioned to any person acting or refraining from action as a result of any material provided or published. 
        We accept no liability for any loss occurring from technical faults relating to this website.
        Any information presented on this website shall not in any way constitute a recommendation as to whether you should invest in any cryptocurrency, 
        product, or investment opportunity here or elsewhere. Past performance is not an indication of future performance.</p>
    </div>
  )
}

export default DisclaimerText